import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { fleetSection } from '../mock/content';
import FleetSlider from './FleetSlider';

const Fleet = () => {
  const { lang } = useApp();
  const s = fleetSection[lang] || fleetSection.en;
  const more = { de: 'Ganze Flotte ansehen', en: 'View full fleet', fr: 'Voir toute la flotte', it: 'Vedi tutta la flotta' }[lang];
  return (
    <section id="fleet" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div className="max-w-2xl">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-[color:var(--brand-dark)]">{s.title}</h2>
            <p className="mt-4 text-gray-500 leading-relaxed">{s.subtitle}</p>
          </div>
          <Link to="/fleet" className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 font-bold text-sm border-2 whitespace-nowrap transition-colors hover:bg-[color:var(--brand-dark)] hover:text-white" style={{ borderColor: 'var(--brand-dark)', color: 'var(--brand-dark)' }}>
            {more} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <FleetSlider />
      </div>
    </section>
  );
};

export default Fleet;
